import {IModalHelper, ModalHelper} from "../../helpers/utils/modalhelper";
import {ParentView} from "../parentView";
import {EventTypes} from "../../helpers/eventtypes";
import {ToastType} from "../../helpers/toasttype";

class ForgotPasswordView extends ParentView {
   
    modalHelper: IModalHelper;
    constructor(formId: string, btnSaveId: string) {
        super(formId, btnSaveId);
               this.modalHelper = new ModalHelper(this.constants.AppVariables.ModalDivId); 
    }
    InitView(): void {
        //this.utility.hideDiv("spinner");
        let obj = this;
        let btnSave: HTMLButtonElement = <HTMLButtonElement>(document.getElementById(this.btnSaveId) as HTMLButtonElement);
        if (btnSave) {           
            btnSave!.addEventListener("click", function (event) {
                if (obj.utility.ValidateForm(obj.formId)) {
                    obj.utility.sayToast("Submitting Form", ToastType.Info);
                }
                else {
                    event.preventDefault();   
                    obj.utility.sayToast("Please correct Errors!", ToastType.Error);
                }
            });
        } 
    }
}
export {ForgotPasswordView }
/* add Listener */
document.addEventListener(EventTypes.DOMContentLoaded, () => {
    let obj: ForgotPasswordView = new ForgotPasswordView("ForgotPassword","btnforgotpassword");
    obj.InitView();   
});
